var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEntrepreneurshipAndStartUps = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Startup-Launch-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Startup Launch 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.24 16H23a1 1 0 0 0 0.18 -2 0.26 0.26 0 0 1 -0.2 -0.21 1 1 0 0 0 -1 -0.83 1 1 0 0 0 -1 1 2.35 2.35 0 0 0 -1 4.29l1.88 1.26a0.3 0.3 0 0 1 0.14 0.26 0.31 0.31 0 0 1 -0.31 0.31H19.9a1 1 0 0 0 -1 1 1 1 0 0 0 0.83 1 0.25 0.25 0 0 1 0.21 0.21 1 1 0 0 0 2 0 0.25 0.25 0 0 1 0.2 -0.22A2.34 2.34 0 0 0 24 19.74a2.36 2.36 0 0 0 -1.05 -2l-1.89 -1.25a0.33 0.33 0 0 1 -0.13 -0.26 0.31 0.31 0 0 1 0.31 -0.23Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.76 8.05H1a1 1 0 0 0 -0.18 2 0.26 0.26 0 0 1 0.2 0.21 1 1 0 0 0 1 0.83 1 1 0 0 0 1 -0.87 0.26 0.26 0 0 1 0.2 -0.21 2.35 2.35 0 0 0 0.81 -4.26L2.19 4.52a0.3 0.3 0 0 1 -0.14 -0.26 0.31 0.31 0 0 1 0.31 -0.26H4.1a1 1 0 0 0 0.19 -2 0.25 0.25 0 0 1 -0.21 -0.21 1 1 0 0 0 -2 0.19 2.36 2.36 0 0 0 -1 4.3l1.86 1.2a0.33 0.33 0 0 1 0.13 0.26 0.31 0.31 0 0 1 -0.31 0.31Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58 18.19c-1.08 1.07 -1.32 3.59 -1.37 4.43a0.24 0.24 0 0 0 0.07 0.2 0.3 0.3 0 0 0 0.2 0.08c0.85 -0.06 3.36 -0.3 4.44 -1.38a2.29 2.29 0 0 0 0 -3.34 2.52 2.52 0 0 0 -1.71 -0.73 2.28 2.28 0 0 0 -1.63 0.74Z",
    fill: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m14.66 17.11 -0.27 -0.78c3.77 -2.34 7 -5.27 6.19 -11.5a0.54 0.54 0 0 0 -0.5 -0.47c-6.26 -0.47 -9 2.88 -11.18 6.76l-0.8 -0.24a2.9 2.9 0 0 0 -2.81 0.83L4 13a1.13 1.13 0 0 0 -0.27 1.1 1.08 1.08 0 0 0 0.28 0.47 1 1 0 0 0 0.57 0.27l2.7 0.48 2.92 2.78 0.6 2.65a1.14 1.14 0 0 0 0.31 0.57 1 1 0 0 0 0.48 0.26 1.14 1.14 0 0 0 1.09 -0.32L14 20a2.9 2.9 0 0 0 0.66 -2.89Zm-0.25 -6.29a1.63 1.63 0 1 1 2.31 -0.06 1.64 1.64 0 0 1 -2.31 0.06Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEntrepreneurshipAndStartUps);
export default ForwardRef;